export default __webpack_public_path__ + "static/create-vm-v2-543d088ea3d6f778c95b772afc56c096.jpg";